import React, { useCallback } from 'react';
import { HouseCategory } from '@search/filter-enums/enums/HouseCategory';
import { Select, useMultipleSelect } from '@vtblife/uikit';
import { SelectMode, OptionType, SelectProps } from '@vtblife/uikit/legacy';
import { HouseCategoryFilter } from '../../../../../filters/models/Filter';

interface IDesktopHouseTypeFilterViewProps {
    filter: HouseCategoryFilter;
    onChange: (filter: HouseCategoryFilter) => void;
}

const selectOptions = [ {
    value: HouseCategory.STANDALONE,
    label: 'Отдельный дом'
}, {
    value: HouseCategory.PART_OF_HOUSE,
    label: 'Часть дома'
}, {
    value: HouseCategory.TOWNHOUSE,
    label: 'Таунхаус'
}, {
    value: HouseCategory.DUPLEX,
    label: 'Дуплекс'
} ];

type Mutable<T> = {
    -readonly[P in keyof T]: T[P]
};

export const DesktopHouseTypeFilterView: React.FC<IDesktopHouseTypeFilterViewProps> = ({
    filter,
    onChange
}) => {
    const handleChange = useCallback<
        NonNullable<SelectProps<OptionType<HouseCategory>, SelectMode.Multiple>['onChange']>
    >(value => {
        onChange(new HouseCategoryFilter(value as Mutable<typeof value>));
    }, [ onChange ]);

    const {
        handleChange: handleChangeSelect,
        is,
        selectedText
    } = useMultipleSelect<HouseCategory>(
        handleChange,
        {
            selected: filter.categories,
            texts: selectOptions.map(({ value, label }) => ({ value, text: label }))
        }
    );

    return (
        <Select mode='multiple' onChange={handleChangeSelect}>
            <Select.Button dataTest='filter-house-trigger'>
                {filter.categories.length > 0 ? selectedText : 'Тип дома'}
            </Select.Button>
            <Select.Content>
                {selectOptions.map(({ value, label }) => (
                    <Select.Option
                        key={value}
                        selected={is(value)}
                        value={value}
                    >{label}</Select.Option>
                ))}
            </Select.Content>
        </Select>
    );
};
